import type {
  EvidenceQuote,
  FirstPass,
  PresentationState,
  SecondPass,
  ThirdPass,
  WatchdogProposal,
  WatchdogPublished,
} from '../types';

export { WATCHDOG_SCHEMA_VERSION as WATCHDOG_PUBLISHED_SCHEMA_VERSION } from '../types';
export type {
  EvidenceQuote,
  FirstPass,
  PresentationState,
  SecondPass,
  ThirdPass,
  WatchdogProposal,
};
export type WatchdogPublishedFeed = WatchdogPublished;

export interface AffectedProvision {
  section_id: string;
  section_title?: string;
  quoted_text: string;
  democratic_concern: string;
  evidence_type: 'direct_textual' | 'institutional_inference' | 'hypothetical_abuse' | 'uncertainty';
}

export interface AbuseScenarioStructured {
  scenario_title: string;
  affected_sections?: string[];
  textual_evidence?: string;
  mechanism: string;
  trigger_conditions: string;
  who_could_misuse: string;
  against_whom: string;
  realistic_likelihood: 'low' | 'medium' | 'high';
  why_not_just_theoretical: string;
  what_would_block_it: string;
  evidence_type: 'direct_textual' | 'institutional_inference' | 'hypothetical_abuse' | 'uncertainty';
}

export interface CriticalReview {
  first_pass_assessment: {
    confirmed: string[];
    rejected: string[];
    refined: string[];
    missed_by_first_pass: string[];
  };
  second_pass_assessment: {
    confirmed: string[];
    rejected: string[];
    refined: string[];
    missed_by_second_pass: string[];
  };
  divergence_summary: string;
}

export interface ThirdPassV2 {
  schema_version: 2;
  independent_reading_summary: string;
  critical_review_of_prior_passes: CriticalReview;
  affected_provisions: AffectedProvision[];
  abuse_scenarios: AbuseScenarioStructured[];
  final_alert: 'yes' | 'no';
  final_risk_level: 'low' | 'medium' | 'high';
  final_score: number;
  summary: string;
  plain_explanation: string;
  reasons: string[];
  constitutional_relevance: 'low' | 'medium' | 'high';
  democratic_impact_areas: string[];
  key_mechanisms: string[];
  confidence: number;
}

export type AnyThirdPass = ThirdPass | ThirdPassV2;

export function isThirdPassV2(tp: AnyThirdPass | null | undefined): tp is ThirdPassV2 {
  return Boolean(tp && (tp as ThirdPassV2).schema_version === 2);
}
